<template>
  <div class="tab-pane-inner tab-pane-prompt-config">
    <div class="prompt-mode-switch-wrap">
      <button
        type="button"
        class="prompt-mode-btn"
        :class="{ 'is-active': effectivePromptMode === PROMPT_MODE.FREE }"
        @click="setPromptMode(PROMPT_MODE.FREE)"
      >
        自由模式
      </button>
      <button
        type="button"
        class="prompt-mode-btn"
        :class="{ 'is-active': effectivePromptMode === PROMPT_MODE.STRUCTURED }"
        @click="setPromptMode(PROMPT_MODE.STRUCTURED)"
      >
        结构化模式
      </button>
    </div>

    <div v-if="effectivePromptMode === PROMPT_MODE.FREE" class="prompt-free-panel">
      <LlmTextareaWithInsertParam
        ref="freePromptInput"
        v-model="form.customPrompt"
        class="prompt-free-textarea"
        :rows="28"
        placeholder="请输入系统提示词，例如：你是一名经验丰富的电销顾问，负责商标驳回复审业务的外呼..."
        :maxlength="freePromptLimit"
        :customer-info-params="form.customerInfoParams"
        :memory-enabled="memoryEnabled"
      />
      <p class="prompt-free-tip">请勿输入违法违规内容，系统可能会进行合规性检查。</p>
    </div>

    <LlmBusinessFlowTab
      v-else
      :form="form"
      :flow-section-order.sync="flowSectionOrderSync"
      :custom-flow-sections="customFlowSections"
      :flow-section-titles="flowSectionTitles"
      :expanded="expanded"
      :flow-guide-expanded="flowGuideExpanded"
      :fixed-title-show-input="fixedTitleShowInput"
      :custom-title-show-input="customTitleShowInput"
      :intent-tag="intentTag"
      :get-role-info-text-for-prompt="getRoleInfoTextForPrompt"
      :memory-enabled="memoryEnabled"
    />
  </div>
</template>

<script>
import { PROMPT_MODE } from '../../constants/flowSection'
import LlmBusinessFlowTab from '../business-flow/index.vue'
import TextareaWithInsertParam from '../shared/TextareaWithInsertParam.vue'

export default {
  name: 'LlmPromptConfigTab',
  components: {
    LlmBusinessFlowTab,
    LlmTextareaWithInsertParam: TextareaWithInsertParam,
  },
  props: {
    form: { type: Object, required: true },
    promptMode: { type: String, required: true },
    flowSectionOrder: { type: Array, required: true },
    customFlowSections: { type: Array, required: true },
    flowSectionTitles: { type: Object, required: true },
    expanded: { type: Object, required: true },
    flowGuideExpanded: { type: Object, required: true },
    fixedTitleShowInput: { type: Object, required: true },
    customTitleShowInput: { type: Object, required: true },
    intentTag: { type: Object, required: true },
    getRoleInfoTextForPrompt: { type: Function, required: true },
    memoryEnabled: { type: Boolean, default: false },
  },
  data() {
    return {
      PROMPT_MODE,
      freePromptLimit: 40000,
    }
  },
  computed: {
    effectivePromptMode() {
      const m =
        this.promptMode != null ? String(this.promptMode).trim().toLowerCase() : ''
      if (m === PROMPT_MODE.STRUCTURED) return PROMPT_MODE.STRUCTURED
      return PROMPT_MODE.FREE
    },
    flowSectionOrderSync: {
      get() {
        return this.flowSectionOrder
      },
      set(val) {
        this.$emit('update:flowSectionOrder', val)
      },
    },
    freePromptLength() {
      const v = this.form.customPrompt != null ? String(this.form.customPrompt) : ''
      return v.length
    },
  },
  methods: {
    setPromptMode(mode) {
      if (mode === this.promptMode) return
      this.$emit('update:promptMode', mode)
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-pane-prompt-config {
  width: 100%;
}

.prompt-mode-switch-wrap {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 37px;
  margin-bottom: 16px;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  background: #f5f7fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.prompt-mode-btn {
  border: none;
  background: transparent;
  color: #909399;
  font-size: 13px;
  line-height: 1.4;
  padding: 0 20px;
  cursor: pointer;
  flex: 0 0 auto;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover:not(.is-active) {
    color: #1e293b;
  }

  &.is-active {
    background: #5668f0;
    color: #fff;
    font-weight: 400;
  }

  &:first-child.is-active {
    border-radius: 3px 0 0 3px;
  }

  &:last-child.is-active {
    border-radius: 0 3px 3px 0;
  }
}

.prompt-free-panel {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
}

::v-deep .prompt-free-textarea.llm-textarea-with-insert textarea.ivu-input {
  min-height: 520px;
  font-size: 14px;
  line-height: 1.6;
}

.prompt-free-tip {
  margin: 10px 0 0;
  font-size: 12px;
  color: #8c8c8c;
  text-align: left;
}
</style>
